import * as React from 'react'

import { DateInput, toDate } from '../shared/dateInput'
import { DateRangeCalendar } from '../shared/dateRangeCalendar'

// MUI's DateCalendar.onChange returns a Date stamped with the time-of-click,
// which can push the UTC date forward by a day for users west of UTC. The old
// react-dates + moment combo always produced midnight-local Dates, so
// downstream consumers (and the backend) expect that. Normalise on entry.
function startOfLocalDay(date: Date): Date {
  const normalised = new Date(date)
  normalised.setHours(0, 0, 0, 0)
  return normalised
}

export const CustomDateModal = ({ close, passedStartDate, setCustomDates, passedEndDate, showResetDatesButton }) => {
  // Accept either a native Date or a moment.Moment from callers; normalise to
  // Date for the internal state so the modal's children all see consistent
  // shapes.
  const [startDate, setStartDate] = React.useState<Date | null>(toDate(passedStartDate))
  const [endDate, setEndDate] = React.useState<Date | null>(toDate(passedEndDate))

  function handleSelectDate(rawDate: Date) {
    const date = startOfLocalDay(rawDate)
    // No start, or both already set → start a new range.
    if (!startDate || (startDate && endDate)) {
      setStartDate(date)
      setEndDate(null)
      return
    }
    // Have start, no end. If the click is before start, replace start;
    // otherwise it's the end of the range.
    if (date < startDate) {
      setStartDate(date)
    } else {
      setEndDate(date)
    }
  }

  function handleClickApply() {
    setCustomDates(startDate, endDate)
    close()
  }

  function handleResetDates() {
    setCustomDates(null, null)
    close()
  }

  let applyClassName = "quill-button medium green contained focus-on-light"

  applyClassName += startDate && endDate ? '' : ' disabled'

  return (
    <div className="modal-container custom-date-modal-container">
      <div className="modal-background" />
      <div className="custom-date-modal quill-modal modal-body">
        <h2>Select custom date range</h2>
        <div className="custom-date-modal-inputs">
          <DateInput ariaLabel="Start date" className="custom-date-modal-input" date={startDate} setDate={setStartDate} />
          <DateInput ariaLabel="End date" className="custom-date-modal-input" date={endDate} setDate={setEndDate} />
        </div>
        <DateRangeCalendar endDate={endDate} onSelectDate={handleSelectDate} startDate={startDate} />
        <div className="button-section">
          {showResetDatesButton && (
            <div className="reset-dates-button-container">
              <button className="quill-button medium green contained focus-on-light" onClick={handleResetDates} type="button">Reset dates</button>
            </div>
          )}
          <button className="quill-button medium green outlined focus-on-light" onClick={close} type="button">Cancel</button>
          <button className={applyClassName} disabled={!(startDate && endDate)} onClick={handleClickApply} type="button">Apply</button>
        </div>
      </div>
    </div>
  )
}

export default CustomDateModal
